import React, { useContext, useState } from 'react';
import { EditUtmModalView, EditUtmModalViewProps } from './EditUtmModal.view';
import { useForm, UseFormReturn } from 'react-hook-form';
import { FormOptions } from '../../../../constants/form';
import { UpdateUtmSettingsMutationFn, UpdateWorkspaceSettingsInput, UtmInput } from '../../../../models/graphql';
import { addTokenCharsToUTMField, removeTokenCharsFromUTMField } from '../../../../helpers/placeholderHelpers';
import { triggerErrorToast } from '../../../../helpers/triggerErrorToast';
import { AppContext } from '../../../../providers/AppProvider';

export type EditUtmModalControllerProps = Omit<EditUtmModalViewProps, 'onSubmit' | 'submitted' | 'useFormInstance'> & {
  campaign: UtmInput;
  updateUtmSettings: UpdateUtmSettingsMutationFn;
};

export const EditUtmModalController = (props: EditUtmModalControllerProps): JSX.Element => {
  const [submitted, setSubmitted] = useState<boolean>(false);
  const { selectedWorkspaceId } = useContext(AppContext);
  const defaultFormValues: Record<string, string | boolean> = {
    source: removeTokenCharsFromUTMField(props.campaign.source),
    medium: removeTokenCharsFromUTMField(props.campaign.medium),
    campaign: removeTokenCharsFromUTMField(props.campaign.campaign),
    term: removeTokenCharsFromUTMField(props.campaign.term),
    content: removeTokenCharsFromUTMField(props.campaign.content)
  };

  const useFormInstance: UseFormReturn = useForm({
    ...FormOptions,
    defaultValues: defaultFormValues
  });

  const onSubmit = (data: { source: string; medium: string; campaign: string; term: string; content: string }) => {
    setSubmitted(true);

    const utmTracking: UpdateWorkspaceSettingsInput['utmTracking'] = {
      source: addTokenCharsToUTMField(data.source),
      medium: addTokenCharsToUTMField(data.medium),
      campaign: addTokenCharsToUTMField(data.campaign),
      term: addTokenCharsToUTMField(data.term),
      content: addTokenCharsToUTMField(data.content)
    };

    if (selectedWorkspaceId) {
      if (!props.submitCallback) {
        props
          .updateUtmSettings({ variables: { input: { utmTracking }, workspaceId: selectedWorkspaceId } })
          .then(() => {
            props.onClose();
          })
          .catch(e => {
            triggerErrorToast('Bitly Delete Error')(e);
            setSubmitted(false);
          });
      } else {
        props.submitCallback({
          ...(props.disabledFields?.includes('source') ? {} : { source: data.source }),
          ...(props.disabledFields?.includes('medium') ? {} : { medium: data.medium }),
          ...(props.disabledFields?.includes('campaign') ? {} : { campaign: data.campaign }),
          ...(props.disabledFields?.includes('content') ? {} : { content: data.content }),
          ...(props.disabledFields?.includes('term') ? {} : { term: data.term })
        });
        props.onClose();
      }
    }
  };

  const viewProps = { ...props, onSubmit, submitted, useFormInstance } as EditUtmModalViewProps;
  return <EditUtmModalView {...viewProps} />;
};
